// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoices-container {
  padding: 20px;
  background-color: #f8f9fa;
}
.invoices-container .cancel-select-btn {
  padding: 8px 18px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.invoices-container input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--primary-color);
}
.invoices-container .checkbox-fade {
  opacity: 0;
  transform: scale(0.8);
}
.invoices-container .filter-group label {
  display: block;
  margin-bottom: 8px;
}
.invoices-container .no-spinner::-webkit-outer-spin-button,
.invoices-container .no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.invoices-container h2 {
  margin-bottom: 2rem;
  font-size: 28px;
  color: #2c3e50;
  text-align: center;
  font-weight: 600;
  position: relative;
}
.invoices-container h2::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);
  border-radius: 2px;
}
.invoices-container .no-invoice-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}
.invoices-container .invoices-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}
.invoices-container .invoices-header .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.invoices-container .invoices-header .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.invoices-container .invoices-header .header-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.invoices-container .invoices-header .header-buttons .send-email-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.invoices-container .invoices-header .header-buttons .filter-dropdown-wrapper {
  position: relative;
  z-index: 10;
}
.invoices-container .invoices-header .header-buttons .filter-dropdown-wrapper .filter-toggle-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
}
.invoices-container .invoice-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  margin-top: 1rem;
}
.invoices-container .invoice-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.invoices-container .invoice-card .header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f1f3f4;
}
.invoices-container .invoice-card .header h4 {
  margin: 0;
  font-size: 1.1rem;
  color: #2c3e50;
  font-weight: 700;
  letter-spacing: -0.3px;
}
.invoices-container .invoice-card .header .status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoices-container .invoice-card .header .status.cancelled {
  background: #ffe6e6;
  color: #dc3545;
}
.invoices-container .invoice-card .header .status.paid {
  background: #e8f5e8;
  color: #28a745;
}
.invoices-container .invoice-card .header .status.pending {
  background: #fff3cd;
  color: #ffc107;
}
.invoices-container .invoice-card .header .status.part-payment {
  background: #e7f3ff;
  color: #0066cc;
}
.invoices-container .invoice-card .updating-status {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.invoices-container .invoice-card .updating-status .status-update-btn {
  padding: 6px 12px;
  background: #17a2b8;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.invoices-container .invoice-card .updating-status .status-update-btn:hover {
  background: #138496;
  transform: translateY(-1px);
}
.invoices-container .invoice-card p {
  margin: 8px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
}
.invoices-container .invoice-card p strong {
  color: #495057;
  font-weight: 600;
}
.invoices-container .invoice-card .items {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f1f3f4;
}
.invoices-container .invoice-card .items > strong {
  display: block;
  margin-bottom: 0.5rem;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}
.invoices-container .invoice-card .items .item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 0.5rem;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px solid #f8f9fa;
  align-items: center;
}
.invoices-container .invoice-card .items .item:last-child {
  border-bottom: none;
}
.invoices-container .invoice-card .items .item div:first-child {
  color: #495057;
  font-weight: 500;
}
.invoices-container .invoice-card .items .item div:nth-child(2) {
  color: #6c757d;
  font-size: 12px;
  text-align: center;
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
}
.invoices-container .invoice-card .items .item div:last-child {
  color: #495057;
  font-weight: 600;
  text-align: right;
  font-size: 13px;
}
.invoices-container .invoice-card .invoice-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid #f1f3f4;
}
.invoices-container .invoice-card .invoice-actions button {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}
.invoices-container .invoice-card .invoice-actions button:first-child {
  background: #17a2b8;
  color: white;
}
.invoices-container .invoice-card .invoice-actions button:first-child:hover {
  background: #138496;
}
.invoices-container .invoice-card .invoice-actions button:last-child {
  background-color: #5cb85c;
  color: white;
}
.invoices-container .invoice-card .invoice-actions button:last-child:hover {
  background: #4cae4c;
}
.invoices-container .invoice-card .invoice-actions button.disabled-btn {
  background-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.invoices-container .invoice-card .invoice-actions button.disabled-btn:hover {
  background: #cccccc;
}
.invoices-container .invoice-card .invoice-actions .preview-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.invoices-container .invoice-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
  margin-top: 1rem;
}
.invoices-container .invoice-table thead {
  background-color: #f1f5f9;
}
.invoices-container .invoice-table thead th {
  padding: 16px 12px;
  text-align: left;
  color: #495057;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 2px solid #e9ecef;
}
.invoices-container .invoice-table tbody tr {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f1f3f4;
}
.invoices-container .invoice-table tbody tr:hover {
  background: #f8f9fa;
}
.invoices-container .invoice-table tbody tr:last-child {
  border-bottom: none;
}
.invoices-container .invoice-table tbody tr:nth-last-child(-n+3) .amount-dropdown .amount-details {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 2px;
  transform: translateY(5px);
  z-index: 1000;
}
.invoices-container .invoice-table tbody tr:nth-last-child(-n+3) .amount-dropdown:hover .amount-details {
  transform: translateY(10px);
}
.invoices-container .invoice-table tbody tr:nth-last-child(-n+3) .amount-dropdown:hover .amount-header .dropdown-arrow {
  transform: rotate(-180deg);
}
.invoices-container .invoice-table tbody tr td {
  padding: 12px;
  font-size: 14px;
  color: #495057;
  vertical-align: top;
}
.invoices-container .invoice-table tbody tr td:last-child {
  white-space: nowrap;
  display: flex;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.cancelled {
  background: #ffe6e6;
  color: #dc3545;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.paid {
  background: #e8f5e8;
  color: #28a745;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.pending {
  background: #fff3cd;
  color: #ffc107;
}
.invoices-container .invoice-table tbody tr td:nth-child(2) .status.part-payment {
  background: #e7f3ff;
  color: #0066cc;
}
.invoices-container .invoice-table .item-list-square {
  margin: 0;
  padding-left: 16px;
}
.invoices-container .invoice-table .item-list-square li {
  margin-bottom: 4px;
  font-size: 13px;
  color: #6c757d;
}
.invoices-container .invoice-table button {
  margin-right: 6px;
  padding: 8px 18px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.invoices-container .invoice-table button:first-child {
  background: #17a2b8;
  color: white;
}
.invoices-container .invoice-table button:first-child:hover {
  background: #138496;
  opacity: 0.9;
}
.invoices-container .invoice-table button:nth-child(2) {
  background: #6c757d;
  color: white;
}
.invoices-container .invoice-table button:nth-child(2):hover {
  background: #6c757d;
}
.invoices-container .invoice-table button:last-child {
  background: #28a745;
  color: white;
}
.invoices-container .invoice-table button:last-child:hover {
  background: #218838;
}
.invoices-container .invoice-table button:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
}
.invoices-container .invoice-table .preview-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.invoices-container .invoice-card .header input[type=checkbox] {
  margin-left: auto;
  margin-right: 8px; /* Adjust for rightmost positioning */
}
.invoices-container .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}
.invoices-container .modal-overlay .send-email-modal {
  background: #ffffff;
  border-radius: 12px;
  padding: 0;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.2s ease;
}
.invoices-container .modal-overlay .send-email-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e9ecef;
}
.invoices-container .modal-overlay .send-email-modal .modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #2c3e50;
  font-weight: 600;
}
.invoices-container .modal-overlay .send-email-modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.invoices-container .modal-overlay .send-email-modal .modal-header .close-btn:hover {
  background: #f8f9fa;
  color: #495057;
}
.invoices-container .modal-overlay .send-email-modal .modal-body {
  padding: 1.5rem;
}
.invoices-container .modal-overlay .send-email-modal .modal-body p {
  margin: 0 0 1.5rem 0;
  color: #6c757d;
  font-size: 16px;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn {
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.paid {
  background: #e8f5e8;
  color: #28a745;
  border: 2px solid #28a745;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.paid:hover {
  background: #28a745;
  color: white;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.cancelled {
  background: #ffe6e6;
  color: #dc3545;
  border: 2px solid #dc3545;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.cancelled:hover {
  background: #dc3545;
  color: white;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.pending {
  background: #fff3cd;
  color: #ffc107;
  border: 2px solid #ffc107;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.pending:hover {
  background: #ffc107;
  color: white;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.part-payment {
  background: #e7f3ff;
  color: #0066cc;
  border: 2px solid #0066cc;
}
.invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn.part-payment:hover {
  background: #0066cc;
  color: white;
}
.invoices-container .loader {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  font-size: 16px;
}
.invoices-container .loader::after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: 10px;
}
@media (max-width: 768px) {
  .invoices-container {
    padding: 1rem;
  }
  .invoices-container .invoices-header {
    flex-direction: column;
    gap: 1rem;
  }
  .invoices-container .invoices-header .view-toggle-wrapper {
    order: 2;
    align-self: flex-start;
  }
  .invoices-container .invoices-header .header-buttons {
    order: 1;
    align-self: flex-end;
    flex-direction: column;
    width: 100%;
  }
  .invoices-container .invoices-header .header-buttons .send-email-btn,
  .invoices-container .invoices-header .header-buttons .filter-toggle-btn {
    width: 100%;
  }
  .invoices-container .invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box {
    width: 280px;
    right: 0;
    left: auto;
  }
  .invoices-container .invoice-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .invoices-container .invoice-card {
    padding: 1rem;
  }
  .invoices-container .invoice-card .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .invoices-container .invoice-card .header .status {
    align-self: flex-end;
  }
  .invoices-container .invoice-card .items .item {
    grid-template-columns: 1fr;
    gap: 0.25rem;
    text-align: left;
  }
  .invoices-container .invoice-card .items .item div:nth-child(2),
  .invoices-container .invoice-card .items .item div:last-child {
    text-align: left;
  }
  .invoices-container .invoice-table {
    font-size: 13px;
    margin-bottom: 60px;
  }
  .invoices-container .invoice-table thead th,
  .invoices-container .invoice-table tbody td {
    padding: 8px;
  }
  .invoices-container h2 {
    font-size: 24px;
  }
  .invoices-container .modal-overlay .send-email-modal {
    width: 95%;
    margin: 1rem;
  }
  .invoices-container .modal-overlay .send-email-modal .modal-body .status-options {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .invoices-container .modal-overlay .send-email-modal .modal-body .status-options .status-option-btn {
    padding: 10px 12px;
    font-size: 12px;
  }
}

.amount-dropdown {
  position: relative;
  cursor: pointer;
}
.amount-dropdown .amount-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.amount-dropdown .amount-header strong {
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}
.amount-dropdown .amount-header .dropdown-arrow {
  font-size: 10px;
  color: #6c757d;
  transition: transform 0.2s ease;
}
.amount-dropdown .amount-details {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-5px);
  transition: all 0.2s ease;
  margin-top: 2px;
}
.amount-dropdown .amount-details .amount-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  font-size: 13px;
  border-bottom: 1px solid #f1f3f4;
}
.amount-dropdown .amount-details .amount-row:last-child {
  border-bottom: none;
}
.amount-dropdown .amount-details .amount-row.pending {
  background: #fff3cd;
  color: #856404;
  font-weight: 600;
}
.amount-dropdown .amount-details .amount-row span:first-child {
  color: #6c757d;
}
.amount-dropdown .amount-details .amount-row span:last-child {
  font-weight: 600;
  color: #495057;
}
.amount-dropdown:hover .amount-header {
  background: #e9ecef;
  border-color: #dee2e6;
}
.amount-dropdown:hover .amount-header .dropdown-arrow {
  transform: rotate(180deg);
}
.amount-dropdown:hover .amount-details {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.table-dropdown .amount-header {
  background: transparent;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
}
.table-dropdown .amount-header:hover {
  background: #f8f9fa;
}
.table-dropdown .amount-header span:first-child {
  font-weight: 600;
  color: #495057;
}
.table-dropdown .amount-details {
  min-width: 150px;
  left: -20px;
}

@media (max-width: 768px) {
  .amount-dropdown .amount-details {
    position: fixed;
    left: 10px;
    right: 10px;
    top: auto;
    bottom: 10px;
    border-radius: 8px;
    margin: 0;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 400;
}
.pagination-settings #invoicePerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #invoicePerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #invoicePerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #invoicePerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Invoices/Invoices.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;AACE;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;AAIE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;AAFJ;AAME;EACE,UAAA;EACA,qBAAA;AAJJ;AAQE;EACE,cAAA;EACA,kBAAA;AANJ;AASM;;EAEJ,wBAAA;EACA,SAAA;AAPF;AAWE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAWI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,0EAAA;EACA,kBAAA;AATN;AAaE;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AAXJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;AAbJ;AAeI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAbN;AAeM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAbR;AAeQ;EACE,eAAA;EACA,cAAA;AAbV;AAgBQ;EACE,yBAAA;AAdV;AAiBQ;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAfV;AAqBI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAnBN;AAqBM;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAnBR;AA4BM;EACE,kBAAA;EACA,WAAA;AA1BR;AA4BQ;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA1BV;AAiCE;EACE,aAAA;EACA,SAAA;EACA,4DAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AAhCJ;AAmCI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAjCN;AAmCM;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAjCR;AAoCM;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAlCR;AAoCQ;EACE,mBAAA;EACA,cAAA;AAlCV;AAqCQ;EACE,mBAAA;EACA,cAAA;AAnCV;AAsCQ;EACE,mBAAA;EACA,cAAA;AApCV;AAuCQ;EACE,mBAAA;EACA,cAAA;AArCV;AA0CI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAxCN;AA0CM;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAxCR;AA0CQ;EACE,mBAAA;EACA,2BAAA;AAxCV;AA6CI;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3CN;AA6CM;EACE,cAAA;EACA,gBAAA;AA3CR;AA+CI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA7CN;AA+CM;EACE,cAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7CR;AAgDM;EACE,aAAA;EACA,kCAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AA9CR;AAgDQ;EACE,mBAAA;AA9CV;AAiDQ;EACE,cAAA;EACA,gBAAA;AA/CV;AAkDQ;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAhDV;AAmDQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAjDV;AAsDI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AApDN;AAsDM;EACE,SAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AApDR;AAsDQ;EACE,mBAAA;EACA,YAAA;AApDV;AAsDU;EACE,mBAAA;AApDZ;AAwDQ;EACE,yBAAA;EAEA,YAAA;AAvDV;AAyDU;EACE,mBAAA;AAvDZ;AA2DQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAzDV;AA2DU;EACE,mBAAA;AAzDZ;AA8DM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA5DR;AAiEE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;AA/DJ;AAmEI;EACE,yBAAA;AAjEN;AAmEM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAjER;AAsEM;EACE,sCAAA;EACA,gCAAA;AApER;AAsEQ;EACE,mBAAA;AApEV;AAuEQ;EACE,mBAAA;AArEV;AA2EY;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;AAzEd;AA6Ec;EACE,2BAAA;AA3EhB;AA8Ec;EACE,0BAAA;AA5EhB;AAkFQ;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAhFV;AAkFU;EACE,mBAAA;EACA,aAAA;AAhFZ;AAqFY;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAnFd;AAqFc;EACE,mBAAA;EACA,cAAA;AAnFhB;AAsFc;EACE,mBAAA;EACA,cAAA;AApFhB;AAuFc;EACE,mBAAA;EACA,cAAA;AArFhB;AAwFc;EACE,mBAAA;EACA,cAAA;AAtFhB;AA8FI;EACE,SAAA;EACA,kBAAA;AA5FN;AA8FM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AA5FR;AAgGI;EAEE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/FN;AAiGM;EACE,mBAAA;EACA,YAAA;AA/FR;AAiGQ;EACE,mBAAA;EACA,YAAA;AA/FV;AAmGM;EACE,mBAAA;EACA,YAAA;AAjGR;AAmGQ;EACE,mBAAA;AAjGV;AAqGM;EACE,mBAAA;EACA,YAAA;AAnGR;AAqGQ;EACE,mBAAA;AAnGV;AAuGM;EACE,8BAAA;EACA,yBAAA;EACA,8BAAA;AArGR;AAyGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAvGN;AA0GA;EACE,iBAAA;EACA,iBAAA,EAAA,qCAAA;AAxGF;AA6GE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;AA3GJ;AA6GI;EACE,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,4BAAA;AA3GN;AA6GM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AA3GR;AA6GQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3GV;AA8GQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AA5GV;AA8GU;EACE,mBAAA;EACA,cAAA;AA5GZ;AAiHM;EACE,eAAA;AA/GR;AAiHQ;EACE,oBAAA;EACA,cAAA;EACA,eAAA;AA/GV;AAkHQ;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAhHV;AAkHU;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAhHZ;AAkHY;EACE,2BAAA;EACA,0CAAA;AAhHd;AAmHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAjHd;AAmHc;EACE,mBAAA;EACA,YAAA;AAjHhB;AAqHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAnHd;AAqHc;EACE,mBAAA;EACA,YAAA;AAnHhB;AAuHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArHd;AAuHc;EACE,mBAAA;EACA,YAAA;AArHhB;AAyHY;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAvHd;AAyHc;EACE,mBAAA;EACA,YAAA;AAvHhB;AAiIE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA/HJ;AAiII;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;AA/HN;AAoIE;EAtsBF;IAusBI,aAAA;EAjIF;EAmIE;IACE,sBAAA;IACA,SAAA;EAjIJ;EAmII;IACE,QAAA;IACA,sBAAA;EAjIN;EAoII;IACE,QAAA;IACA,oBAAA;IACA,sBAAA;IACA,WAAA;EAlIN;EAoIM;;IAEE,WAAA;EAlIR;EAsIQ;IACE,YAAA;IACA,QAAA;IACA,UAAA;EApIV;EA0IE;IACE,0BAAA;IACA,SAAA;EAxIJ;EA2IE;IACE,aAAA;EAzIJ;EA2II;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EAzIN;EA2IM;IACE,oBAAA;EAzIR;EA6II;IACE,0BAAA;IACA,YAAA;IACA,gBAAA;EA3IN;EA6IM;;IAEE,gBAAA;EA3IR;EAgJE;IACE,eAAA;IAEA,mBAAA;EA/IJ;EAiJI;;IAEE,YAAA;EA/IN;EAmJE;IACE,eAAA;EAjJJ;EAqJI;IACE,UAAA;IACA,YAAA;EAnJN;EAsJQ;IACE,8BAAA;IACA,QAAA;EApJV;EAsJU;IACE,kBAAA;IACA,eAAA;EApJZ;AACF;;AA6JA;EACE,kBAAA;EACA,eAAA;AA1JF;AA4JE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AA1JJ;AA4JI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA1JN;AA6JI;EACE,eAAA;EACA,cAAA;EACA,+BAAA;AA3JN;AA+JE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AA7JJ;AA+JI;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AA7JN;AA+JM;EACE,mBAAA;AA7JR;AAgKM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA9JR;AAiKM;EACE,cAAA;AA/JR;AAkKM;EACE,gBAAA;EACA,cAAA;AAhKR;AAsKI;EACE,mBAAA;EACA,qBAAA;AApKN;AAsKM;EACE,yBAAA;AApKR;AAwKI;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAtKN;;AA6KE;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AA1KJ;AA4KI;EACE,mBAAA;AA1KN;AA6KI;EACE,gBAAA;EACA,cAAA;AA3KN;AA+KE;EACE,gBAAA;EACA,WAAA;AA7KJ;;AAkLA;EAEI;IACE,eAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;IACA,kBAAA;IACA,SAAA;EAhLJ;AACF;AAqLA;EACE;IACE,uBAAA;EAnLF;EAsLA;IACE,yBAAA;EApLF;AACF;AAuLA;EACE;IACE,UAAA;IACA,4BAAA;EArLF;EAwLA;IACE,UAAA;IACA,wBAAA;EAtLF;AACF;AAyLA;EACE;IACE,UAAA;EAvLF;EA0LA;IACE,UAAA;EAxLF;AACF;AA2LA;EACE;IACE,UAAA;IACA,qBAAA;EAzLF;EA4LA;IACE,UAAA;IACA,mBAAA;EA1LF;AACF;AA6LA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AA3LF;AA8LE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA5LJ;AAgME;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AApMJ;AAuMI;EACE,yBAAA;AArMN;AAyMI;EACE,wDAAA;EACA,uBAAA;AAvMN;AA2MI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAzMN","sourcesContent":[".invoices-container {\r\n  padding: 20px;\r\n  background-color: #f8f9fa;\r\n\r\n  .cancel-select-btn {\r\n  padding: 8px 18px;\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n\r\n}\r\n\r\n\r\n  input[type=\"checkbox\"] {\r\n    width: 16px;\r\n    height: 16px;\r\n    cursor: pointer;\r\n    accent-color: var(--primary-color);\r\n  }\r\n\r\n  // GSAP checkbox animations - minimal styling\r\n  .checkbox-fade {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n  }\r\n\r\n\r\n  .filter-group label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n      .no-spinner::-webkit-outer-spin-button,\r\n.no-spinner::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n\r\n  h2 {\r\n    margin-bottom: 2rem;\r\n    font-size: 28px;\r\n    color: #2c3e50;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    position: relative;\r\n\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: -8px;\r\n      left: 50%;\r\n      transform: translateX(-50%);\r\n      width: 60px;\r\n      height: 3px;\r\n      background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);\r\n      border-radius: 2px;\r\n    }\r\n  }\r\n\r\n  .no-invoice-found {\r\n    text-align: center;\r\n    font-size: 1.1rem;\r\n    color: var(--text-color-medium);\r\n    padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n    background: var(--card-bg);\r\n    border-radius: 0.75rem;\r\n    border: 1px dashed var(--border-color);\r\n    box-shadow: 0 2px 5px var(--shadow-light);\r\n    margin-top: calc(var(--spacing-unit) * 2);\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  // Header section with controls\r\n  .invoices-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n    gap: 1rem;\r\n\r\n    .view-toggle-wrapper {\r\n      display: flex;\r\n      gap: 0.5rem;\r\n      align-items: center;\r\n\r\n      .view-toggle-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.3rem;\r\n        padding: 0.3rem 0.6rem;\r\n        font-size: 0.85rem;\r\n        font-weight: 500;\r\n        background-color: transparent;\r\n        color: #444;\r\n        border: 1px solid var(--border-color);\r\n        border-radius: 6px;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n\r\n        svg {\r\n          font-size: 1rem;\r\n          color: inherit;\r\n        }\r\n\r\n        &:hover {\r\n          background-color: #f3f4f6;\r\n        }\r\n\r\n        &.active {\r\n          background-color: #e5e7eb;\r\n          color: #222;\r\n          border-color: #cbd5e1;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Header buttons container\r\n    .header-buttons {\r\n      display: flex;\r\n      gap: 0.5rem;\r\n      align-items: center;\r\n\r\n      .send-email-btn {\r\n        padding: 8px 18px;\r\n        background: var(--primary-color);\r\n        color: white;\r\n        border: none;\r\n        border-radius: 0.5rem;\r\n        cursor: pointer;\r\n        font-weight: 500;\r\n        transition: all 0.2s ease;\r\n\r\n        // &:hover {\r\n        //   background: #5a6fd8;\r\n        //   transform: translateY(-1px);\r\n        //   box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\r\n        // }\r\n      }\r\n\r\n      .filter-dropdown-wrapper {\r\n        position: relative;\r\n        z-index: 10;\r\n\r\n        .filter-toggle-btn {\r\n          padding: 8px 18px;\r\n          background: var(--primary-color);\r\n          color: white;\r\n          border: none;\r\n          border-radius: 8px;\r\n          cursor: pointer;\r\n          font-weight: 500;\r\n        }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n  .invoice-grid {\r\n    display: grid;\r\n    gap: 1rem;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  .invoice-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    background: #ffffff;\r\n    border-radius: 12px;\r\n    padding: 1.5rem;\r\n    border: 1px solid #e9ecef;\r\n    transition: all 0.3s ease;\r\n    position: relative;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n\r\n\r\n    .header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: flex-start;\r\n      margin-bottom: 1rem;\r\n      padding-bottom: 1rem;\r\n      border-bottom: 1px solid #f1f3f4;\r\n\r\n      h4 {\r\n        margin: 0;\r\n        font-size: 1.1rem;\r\n        color: #2c3e50;\r\n        font-weight: 700;\r\n        letter-spacing: -0.3px;\r\n      }\r\n\r\n      .status {\r\n        padding: 4px 12px;\r\n        border-radius: 20px;\r\n        font-size: 11px;\r\n        font-weight: 700;\r\n        text-transform: uppercase;\r\n        letter-spacing: 0.5px;\r\n\r\n        &.cancelled {\r\n          background: #ffe6e6;\r\n          color: #dc3545;\r\n        }\r\n\r\n        &.paid {\r\n          background: #e8f5e8;\r\n          color: #28a745;\r\n        }\r\n\r\n        &.pending {\r\n          background: #fff3cd;\r\n          color: #ffc107;\r\n        }\r\n\r\n        &.part-payment {\r\n          background: #e7f3ff;\r\n          color: #0066cc;\r\n        }\r\n      }\r\n    }\r\n\r\n    .updating-status {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      margin-bottom: 1rem;\r\n\r\n      .status-update-btn {\r\n        padding: 6px 12px;\r\n        background: #17a2b8;\r\n        color: white;\r\n        border: none;\r\n        border-radius: 6px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n          background: #138496;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n    }\r\n\r\n    p {\r\n      margin: 8px 0;\r\n      color: #6c757d;\r\n      font-size: 14px;\r\n      line-height: 1.4;\r\n\r\n      strong {\r\n        color: #495057;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n\r\n    .items {\r\n      margin-top: 1rem;\r\n      padding-top: 1rem;\r\n      border-top: 1px solid #f1f3f4;\r\n\r\n      >strong {\r\n        display: block;\r\n        margin-bottom: 0.5rem;\r\n        color: #495057;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .item {\r\n        display: grid;\r\n        grid-template-columns: 2fr 1fr 1fr;\r\n        gap: 0.5rem;\r\n        padding: 8px 0;\r\n        font-size: 13px;\r\n        border-bottom: 1px solid #f8f9fa;\r\n        align-items: center;\r\n\r\n        &:last-child {\r\n          border-bottom: none;\r\n        }\r\n\r\n        div:first-child {\r\n          color: #495057;\r\n          font-weight: 500;\r\n        }\r\n\r\n        div:nth-child(2) {\r\n          color: #6c757d;\r\n          font-size: 12px;\r\n          text-align: center;\r\n          background: #f8f9fa;\r\n          padding: 2px 6px;\r\n          border-radius: 4px;\r\n        }\r\n\r\n        div:last-child {\r\n          color: #495057;\r\n          font-weight: 600;\r\n          text-align: right;\r\n          font-size: 13px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .invoice-actions {\r\n      display: flex;\r\n      gap: 8px;\r\n      margin-top: auto;\r\n      padding-top: 1rem;\r\n      border-top: 1px solid #f1f3f4;\r\n\r\n      button {\r\n        flex: 1;\r\n        padding: 8px 12px;\r\n        border: none;\r\n        border-radius: 6px;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n        font-size: 13px;\r\n\r\n        &:first-child {\r\n          background: #17a2b8;\r\n          color: white;\r\n\r\n          &:hover {\r\n            background: #138496;\r\n          }\r\n        }\r\n\r\n        &:last-child {\r\n          background-color: #5cb85c;\r\n          ;\r\n          color: white;\r\n\r\n          &:hover {\r\n            background: #4cae4c;\r\n          }\r\n        }\r\n\r\n        &.disabled-btn {\r\n          background-color: #cccccc;\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n\r\n          &:hover {\r\n            background: #cccccc;\r\n          }\r\n        }\r\n      }\r\n\r\n      .preview-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 6px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .invoice-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    background: #ffffff;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n    border: 1px solid #e9ecef;\r\n    margin-top: 1rem;\r\n    // ADDED: Space at bottom for dropdowns\r\n    //margin-bottom: 100px;\r\n\r\n    thead {\r\n      background-color: #f1f5f9;\r\n\r\n      th {\r\n        padding: 16px 12px;\r\n        text-align: left;\r\n        color: #495057;\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n        border-bottom: 2px solid #e9ecef;\r\n      }\r\n    }\r\n\r\n    tbody {\r\n      tr {\r\n        transition: background-color 0.2s ease;\r\n        border-bottom: 1px solid #f1f3f4;\r\n\r\n        &:hover {\r\n          background: #f8f9fa;\r\n        }\r\n\r\n        &:last-child {\r\n          border-bottom: none;\r\n        }\r\n\r\n        // ADDED: Target last 3 rows for upward dropdowns\r\n        &:nth-last-child(-n+3) {\r\n          .amount-dropdown {\r\n            .amount-details {\r\n              top: auto;\r\n              bottom: 100%;\r\n              margin-top: 0;\r\n              margin-bottom: 2px;\r\n              transform: translateY(5px);\r\n              z-index: 1000;\r\n            }\r\n\r\n            &:hover {\r\n              .amount-details {\r\n                transform: translateY(10px);\r\n              }\r\n\r\n              .amount-header .dropdown-arrow {\r\n                transform: rotate(-180deg); // Flip arrow for upward dropdown\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        td {\r\n          padding: 12px;\r\n          font-size: 14px;\r\n          color: #495057;\r\n          vertical-align: top;\r\n\r\n          &:last-child {\r\n            white-space: nowrap;\r\n            display: flex;\r\n          }\r\n\r\n          // Status column styling\r\n          &:nth-child(2) {\r\n            .status {\r\n              display: inline-block;\r\n              padding: 4px 12px;\r\n              border-radius: 20px;\r\n              font-size: 11px;\r\n              font-weight: 700;\r\n              text-transform: uppercase;\r\n              letter-spacing: 0.5px;\r\n\r\n              &.cancelled {\r\n                background: #ffe6e6;\r\n                color: #dc3545;\r\n              }\r\n\r\n              &.paid {\r\n                background: #e8f5e8;\r\n                color: #28a745;\r\n              }\r\n\r\n              &.pending {\r\n                background: #fff3cd;\r\n                color: #ffc107;\r\n              }\r\n\r\n              &.part-payment {\r\n                background: #e7f3ff;\r\n                color: #0066cc;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .item-list-square {\r\n      margin: 0;\r\n      padding-left: 16px;\r\n\r\n      li {\r\n        margin-bottom: 4px;\r\n        font-size: 13px;\r\n        color: #6c757d;\r\n      }\r\n    }\r\n\r\n    button {\r\n      // height: 1.5rem;\r\n      margin-right: 6px;\r\n      padding: 8px 18px;\r\n      font-size: 12px;\r\n      border: none;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      font-weight: 500;\r\n      transition: all 0.2s ease;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n\r\n      &:first-child {\r\n        background: #17a2b8;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #138496;\r\n          opacity: 0.9;\r\n        }\r\n      }\r\n\r\n      &:nth-child(2) {\r\n        background: #6c757d;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #6c757d;\r\n        }\r\n      }\r\n\r\n      &:last-child {\r\n        background: #28a745;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #218838;\r\n        }\r\n      }\r\n\r\n      &:disabled {\r\n        background: #e9ecef !important;\r\n        color: #6c757d !important;\r\n        cursor: not-allowed !important;\r\n      }\r\n    }\r\n\r\n    .preview-btn {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 4px;\r\n    }\r\n  }\r\n.invoice-card .header input[type=\"checkbox\"] {\r\n  margin-left: auto;\r\n  margin-right: 8px; /* Adjust for rightmost positioning */\r\n}\r\n\r\n\r\n  // Send Email Modal Styles\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    animation: fadeIn 0.2s ease;\r\n\r\n    .send-email-modal {\r\n      background: #ffffff;\r\n      border-radius: 12px;\r\n      padding: 0;\r\n      width: 90%;\r\n      max-width: 500px;\r\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n      animation: scaleIn 0.2s ease;\r\n\r\n      .modal-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 1.5rem;\r\n        border-bottom: 1px solid #e9ecef;\r\n\r\n        h3 {\r\n          margin: 0;\r\n          font-size: 20px;\r\n          color: #2c3e50;\r\n          font-weight: 600;\r\n        }\r\n\r\n        .close-btn {\r\n          background: none;\r\n          border: none;\r\n          font-size: 24px;\r\n          color: #6c757d;\r\n          cursor: pointer;\r\n          padding: 0;\r\n          width: 30px;\r\n          height: 30px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          border-radius: 50%;\r\n          transition: all 0.2s ease;\r\n\r\n          &:hover {\r\n            background: #f8f9fa;\r\n            color: #495057;\r\n          }\r\n        }\r\n      }\r\n\r\n      .modal-body {\r\n        padding: 1.5rem;\r\n\r\n        p {\r\n          margin: 0 0 1.5rem 0;\r\n          color: #6c757d;\r\n          font-size: 16px;\r\n        }\r\n\r\n        .status-options {\r\n          display: grid;\r\n          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n          gap: 12px;\r\n\r\n          .status-option-btn {\r\n            padding: 12px 16px;\r\n            border: none;\r\n            border-radius: 8px;\r\n            font-weight: 600;\r\n            font-size: 14px;\r\n            cursor: pointer;\r\n            transition: all 0.2s ease;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.5px;\r\n\r\n            &:hover {\r\n              transform: translateY(-2px);\r\n              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n            }\r\n\r\n            &.paid {\r\n              background: #e8f5e8;\r\n              color: #28a745;\r\n              border: 2px solid #28a745;\r\n\r\n              &:hover {\r\n                background: #28a745;\r\n                color: white;\r\n              }\r\n            }\r\n\r\n            &.cancelled {\r\n              background: #ffe6e6;\r\n              color: #dc3545;\r\n              border: 2px solid #dc3545;\r\n\r\n              &:hover {\r\n                background: #dc3545;\r\n                color: white;\r\n              }\r\n            }\r\n\r\n            &.pending {\r\n              background: #fff3cd;\r\n              color: #ffc107;\r\n              border: 2px solid #ffc107;\r\n\r\n              &:hover {\r\n                background: #ffc107;\r\n                color: white;\r\n              }\r\n            }\r\n\r\n            &.part-payment {\r\n              background: #e7f3ff;\r\n              color: #0066cc;\r\n              border: 2px solid #0066cc;\r\n\r\n              &:hover {\r\n                background: #0066cc;\r\n                color: white;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Loading state\r\n  .loader {\r\n    text-align: center;\r\n    padding: 3rem;\r\n    color: #6c757d;\r\n    font-size: 16px;\r\n\r\n    &::after {\r\n      content: '';\r\n      display: inline-block;\r\n      width: 20px;\r\n      height: 20px;\r\n      border: 2px solid #f3f3f3;\r\n      border-top: 2px solid var(--primary-color);\r\n      border-radius: 50%;\r\n      animation: spin 1s linear infinite;\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n\r\n  // Responsive design\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n\r\n    .invoices-header {\r\n      flex-direction: column;\r\n      gap: 1rem;\r\n\r\n      .view-toggle-wrapper {\r\n        order: 2;\r\n        align-self: flex-start;\r\n      }\r\n\r\n      .header-buttons {\r\n        order: 1;\r\n        align-self: flex-end;\r\n        flex-direction: column;\r\n        width: 100%;\r\n\r\n        .send-email-btn,\r\n        .filter-toggle-btn {\r\n          width: 100%;\r\n        }\r\n\r\n        .filter-dropdown-wrapper {\r\n          .filter-dropdown-box {\r\n            width: 280px;\r\n            right: 0;\r\n            left: auto;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .invoice-grid {\r\n      grid-template-columns: 1fr;\r\n      gap: 1rem;\r\n    }\r\n\r\n    .invoice-card {\r\n      padding: 1rem;\r\n\r\n      .header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 0.5rem;\r\n\r\n        .status {\r\n          align-self: flex-end;\r\n        }\r\n      }\r\n\r\n      .items .item {\r\n        grid-template-columns: 1fr;\r\n        gap: 0.25rem;\r\n        text-align: left;\r\n\r\n        div:nth-child(2),\r\n        div:last-child {\r\n          text-align: left;\r\n        }\r\n      }\r\n    }\r\n\r\n    .invoice-table {\r\n      font-size: 13px;\r\n      // ADDED: Less margin on mobile\r\n      margin-bottom: 60px;\r\n\r\n      thead th,\r\n      tbody td {\r\n        padding: 8px;\r\n      }\r\n    }\r\n\r\n    h2 {\r\n      font-size: 24px;\r\n    }\r\n\r\n    .modal-overlay {\r\n      .send-email-modal {\r\n        width: 95%;\r\n        margin: 1rem;\r\n\r\n        .modal-body {\r\n          .status-options {\r\n            grid-template-columns: 1fr 1fr;\r\n            gap: 8px;\r\n\r\n            .status-option-btn {\r\n              padding: 10px 12px;\r\n              font-size: 12px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Amount dropdown styles\r\n.amount-dropdown {\r\n  position: relative;\r\n  cursor: pointer;\r\n\r\n  .amount-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 8px 12px;\r\n    background: #f8f9fa;\r\n    border-radius: 6px;\r\n    border: 1px solid #e9ecef;\r\n    transition: all 0.2s ease;\r\n\r\n    strong {\r\n      color: #495057;\r\n      font-size: 14px;\r\n      font-weight: 600;\r\n    }\r\n\r\n    .dropdown-arrow {\r\n      font-size: 10px;\r\n      color: #6c757d;\r\n      transition: transform 0.2s ease;\r\n    }\r\n  }\r\n\r\n  .amount-details {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    right: 0;\r\n    background: white;\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 6px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n    z-index: 10;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: translateY(-5px);\r\n    transition: all 0.2s ease;\r\n    margin-top: 2px;\r\n\r\n    .amount-row {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding: 8px 12px;\r\n      font-size: 13px;\r\n      border-bottom: 1px solid #f1f3f4;\r\n\r\n      &:last-child {\r\n        border-bottom: none;\r\n      }\r\n\r\n      &.pending {\r\n        background: #fff3cd;\r\n        color: #856404;\r\n        font-weight: 600;\r\n      }\r\n\r\n      span:first-child {\r\n        color: #6c757d;\r\n      }\r\n\r\n      span:last-child {\r\n        font-weight: 600;\r\n        color: #495057;\r\n      }\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    .amount-header {\r\n      background: #e9ecef;\r\n      border-color: #dee2e6;\r\n\r\n      .dropdown-arrow {\r\n        transform: rotate(180deg);\r\n      }\r\n    }\r\n\r\n    .amount-details {\r\n      opacity: 1;\r\n      visibility: visible;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n}\r\n\r\n// Table specific dropdown styles\r\n.table-dropdown {\r\n  .amount-header {\r\n    background: transparent;\r\n    border: none;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n\r\n    &:hover {\r\n      background: #f8f9fa;\r\n    }\r\n\r\n    span:first-child {\r\n      font-weight: 600;\r\n      color: #495057;\r\n    }\r\n  }\r\n\r\n  .amount-details {\r\n    min-width: 150px;\r\n    left: -20px;\r\n  }\r\n}\r\n\r\n// Mobile responsive for dropdown\r\n@media (max-width: 768px) {\r\n  .amount-dropdown {\r\n    .amount-details {\r\n      position: fixed;\r\n      left: 10px;\r\n      right: 10px;\r\n      top: auto;\r\n      bottom: 10px;\r\n      border-radius: 8px;\r\n      margin: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes scaleIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.pagination-settings {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  padding: 7px 18px;\r\n  background-color: #E2E8F0;\r\n  border-radius: 6px;\r\n\r\n\r\n  label {\r\n    white-space: nowrap;\r\n    color: #1f2937;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n  }\r\n\r\n\r\n  #invoicePerPageSelect {\r\n    border: none;\r\n    border-radius: 6px;\r\n    outline: none;\r\n    padding: 6px 32px 6px 12px;\r\n    background-color: white;\r\n    font-size: 14px;\r\n    color: #333;\r\n    cursor: pointer;\r\n    min-width: 70px;\r\n\r\n\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n\r\n\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 16px;\r\n\r\n\r\n    transition: all 0.2s ease;\r\n    box-shadow: none !important;\r\n\r\n\r\n    &:hover {\r\n      background-color: #fafafa;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n      background-color: white;\r\n    }\r\n\r\n\r\n    option {\r\n      border: none !important;\r\n      outline: none;\r\n      padding: 4px 8px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
